import React from "react";

function ThemeTab({thingsList, selectedThing, setSelectedThing, additionalClassName }) {

  return (
    <div className={`tab-wrap ${additionalClassName}`}>
      {
        thingsList.map((thing, i) =>
          <button className={`tab-btn ${selectedThing === thing.id ? "clicked" : ""}`}
                  onClick={() => {
                    setSelectedThing(thing.id);
                  }}
                  key={i}
          >
            {thing.title}
          </button>
        )
      }
    </div>
  );
}

export default ThemeTab;
